import {useData} from "vike-react/useData";
import clock from "#/src/assets/svg/clock.svg";
import {ApiBlogPostData} from "#/src/definitions/ApiDefinitions";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {TimeDisplay} from "#/src/components/TimeDisplay";
import {getProfileUrl} from "#/src/utils/profile-url";
import {toast} from "react-toastify";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

export function Header() {
  const {data: postData} = useData() as DataWrapped<ApiBlogPostData>;

  function onShare() {
    navigator.clipboard.writeText(window.location.href);
    toast("Skopiowano link do schowka");
  }

  return <header className="blog-top mt-5">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-10 mx-auto">
          <div className="title">
            <h1 className="blog-title">{postData.article.title}</h1>
          </div>
          <div className="blog-top-info mt-3">
            <div className="article-author">
              <div className="author">
                <AvatarWithFallback user={postData.article.author} className={"avatar avatar-40"}/>
                <a href={getProfileUrl(postData.article.author)} className="author-link">{postData.article.author.username}</a>
              </div>
              <div className="article-date">
                <img src={clock} alt={"Data"}/>
                <span><TimeDisplay className={"ms-2"} date={postData.article.creationDate}/></span>
              </div>
            </div>
            <a href="#" className="btn btn-secondary-outline" onClick={onShare}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" className="me-2">
                <path fill="#788ca0"
                      d="M18 22q-1.25 0-2.125-.875T15 19q0-.175.025-.363t.075-.337l-7.05-4.1q-.425.375-.95.588T6 15q-1.25 0-2.125-.875T3 12q0-1.25.875-2.125T6 9q.575 0 1.1.213t.95.587l7.05-4.1q-.05-.15-.075-.337T15 5q0-1.25.875-2.125T18 2q1.25 0 2.125.875T21 5q0 1.25-.875 2.125T18 8q-.575 0-1.1-.212t-.95-.588L8.9 11.3q.05.15.075.338T9 12q0 .175-.025.363T8.9 12.7l7.05 4.1q.425-.375.95-.587T18 16q1.25 0 2.125.875T21 19q0 1.25-.875 2.125T18 22"/>
              </svg>
              Udostępnij
            </a>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="blog-top-image">
            <img src={`${Attachments.getUrl(AttachmentNamespace.ARTICLE, postData.article)}-high`} alt={postData.article.slug}/>
          </div>
        </div>
      </div>
    </div>
  </header>
}